import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";

export const BlockedScreen = ({ onRestart }) => {
  return (
    <motion.div
      key="blocked"
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -24 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="flex flex-1 flex-col items-center justify-center text-center"
      data-testid="blocked-screen"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-coral/15 text-coral">
        <ShieldAlert size={32} strokeWidth={2} />
      </div>
      <h2 className="mt-6 font-serif text-2xl font-semibold leading-snug text-ink">
        Meglio fermarci qui
      </h2>
      <p className="mt-4 max-w-sm text-base font-light leading-relaxed text-ink/75">
        Per la tua sicurezza, ti consigliamo di parlarne prima con il tuo medico.
        Questo test non è adatto in questa situazione.
      </p>
      <button
        type="button"
        onClick={onRestart}
        data-testid="blocked-restart-button"
        className="mt-10 w-full max-w-xs rounded-2xl bg-coral px-8 py-4 text-lg font-semibold text-white shadow-lg shadow-coral/30 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl active:translate-y-0"
      >
        Rifai il test
      </button>
    </motion.div>
  );
};
